import common from './common'

export default {
  ...common.button,
  color: `white`,
  bg: `alpha`,
  borderColor: `alpha`,
  ':hover': {
    color: `white`,
    bg: `alphaLight`,
    borderColor: `alphaLight`
  }
}
